/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Header, Form, Button, Icon, Message, List } from 'semantic-ui-react';

function defaultState({ number }) {
  return { number };
}

export class EditPhoneModal extends React.Component {
  state = defaultState(this.props)

  callApi = () => {
    const { number } = this.state;
    const { accountId, instance, onUpdate } = this.props;
    if ((number || '').replace(/[^0-9]/g, '').length < 10) {
      this.setState({
        error: {
          log: [{ message: 'That does not appear to be a valid phone number' }],
        },
      });
      return;
    }
    this.setState({ saving: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/identity/user/${accountId}/set-phone`,
        catchErrors: true,
        body: { number, instance },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, saving: false });
      } else {
        onUpdate();
        this.setState({ opened: false, error: null, saving: false });
      }
    });
  }

  render() {
    const { buttonText } = this.props;
    const { opened, error, saving } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button size="mini" floated="right" onClick={() => this.setState({ opened: true })}>{buttonText}</Button>}
      >
        <Header icon="attention" content="Change Phone Number" />
        <Modal.Content>
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot change phone number:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          <Form>
            <Form.Input
              fluid
              type="tel"
              autoComplete="false"
              label="Phone Number"
              placeholder="(555) 555-1212"
              onChange={(e, { value }) => this.setState({ number: value })}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button loading={saving} basic color="blue" onClick={this.callApi}>
            <Icon name="eye" />
            {' '}
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

EditPhoneModal.propTypes = {
  accountId: PT.number,
  instance: PT.string,
  onUpdate: PT.func.isRequired,
  buttonText: PT.string,
};

EditPhoneModal.defaultProps = {
  accountId: 0,
  instance: '',
  buttonText: 'edit',
};
